import { FetchResourceOK } from '../types/FetchResourceOK'
import { Resource } from '../types/Resource'
import isErrorDocument from './isErrorDocument'

// eslint-disable-next-line max-len
export default <R extends Resource>(japiDocument: any): japiDocument is FetchResourceOK<R> => typeof japiDocument === 'object' && ! isErrorDocument(japiDocument) && 'data' in japiDocument && (japiDocument.data === null || typeof japiDocument.data.type === 'string')
